'use client';
import Box from '@mui/material/Box';
import type {NavLink} from '@olympus-frontend/tenant-config';
import {useTranslation} from 'react-i18next';
import {trackFooterTabClick} from '../../analytics';
import {externalLinkProps, FooterLink, type LinkSize} from '../primitives';

export function FooterNavLink({item, size}: {item: NavLink; size?: LinkSize}) {
  const {t} = useTranslation();
  return (
    <Box component="li">
      <FooterLink
        href={item.href}
        size={size}
        onClick={() => {
          trackFooterTabClick(t(item.labelKey), item.key);
        }}
        {...externalLinkProps(item.href)}
      >
        {t(item.labelKey)}
      </FooterLink>
    </Box>
  );
}

FooterNavLink.displayName = 'FooterNavLink';
